import { render, staticRenderFns } from "./ConversationTicketsHistoryView.vue?vue&type=template&id=4d657ba2&scoped=true&"
import script from "./ConversationTicketsHistoryView.vue?vue&type=script&lang=js&"
export * from "./ConversationTicketsHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./ConversationTicketsHistoryView.vue?vue&type=style&index=0&id=4d657ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d657ba2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
